import { render, staticRenderFns } from "./ReferencingInfo.vue?vue&type=template&id=2ebac4dd&"
import script from "./ReferencingInfo.vue?vue&type=script&lang=js&"
export * from "./ReferencingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports